export default __webpack_public_path__ + "static/media/delivery23orange.6b0cd394.svg";